import style from "./LogMultiProgress.module.css";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Slider from "@mui/material/Slider";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";

let playSetInterval;
const step = 1000;

const timestamp2dateform = (timestamp, datetype) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const second = String(date.getSeconds()).padStart(2, "0");

  let formattedDate;
  if (datetype === 1) formattedDate = `${year}/${month}/${day}`;
  if (datetype === 2) formattedDate = `${hour}:${minute}:${second}`;
  return formattedDate.toString() || " - ";
};

const LogMultiProgress = ({ startTimestamp, endTimestamp, updateFunc }) => {
  const [value, setValue] = useState(0);
  const [playStatus, setPlayStatus] = useState(false);
  const sliderRef = useRef(null);
  const [playSpeed, setPlaySpeed] = useState(1);
  const { t } = useTranslation();

  const handleSliderChange = (value) => {
    setValue(value);
  };

  const updateSliderValue = () => {
    setValue((prev) => {
      const nextFrame = prev + step;
      if (nextFrame > parseInt(endTimestamp) - parseInt(startTimestamp)) {
        stopProgress();
        return prev;
      } else {
        return nextFrame;
      }
    });
  };

  useEffect(() => {
    updateFunc(startTimestamp + value);
  }, [startTimestamp, value, updateFunc]);

  const playProgress = () => {
    if (!playStatus) {
      playSetInterval = setInterval(updateSliderValue, 1000 / playSpeed);
      setPlayStatus(true);
    }
  };

  const stopProgress = () => {
    clearInterval(playSetInterval);
    setPlayStatus(false);
  };

  const handleSpeedChange = (speed) => {
    setPlaySpeed(speed);
    if (playStatus) {
      stopProgress();
      playProgress();
    }
  };

  return (
    <div id={style.sliderContainer}>
      <div id={style.mediaControlls}>
        {playStatus ? (
          <PauseCircleOutlineIcon
            sx={{
              width: 40,
              height: 40,
              cursor: "pointer",
              color: "#0275d8",
              marginRight: "10px",
              transition: "color 0.3s ease",
            }}
            onClick={stopProgress}
          />
        ) : (
          <PlayCircleOutlineIcon
            sx={{
              width: 40,
              height: 40,
              cursor: "pointer",
              color: "#0275d8",
              marginRight: "10px",
              transition: "color 0.3s ease",
            }}
            onClick={playProgress}
          />
        )}
        <Box
          sx={{
            minWidth: 80,
            marginRight: "10px",
            "& .MuiOutlinedInput-root": { height: 30 },
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Speed</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={playSpeed}
              label="Speed"
              onChange={(e) => handleSpeedChange(parseFloat(e.target.value))}
            >
              <MenuItem value={1}>{t("Normal")}</MenuItem>
              <MenuItem value={4}>{t("Faster")}</MenuItem>
              <MenuItem value={10}>Max</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box
          sx={{
            minWidth: 80,
            marginRight: "10px",
            "& .MuiOutlinedInput-root": { height: 30 },
          }}
        >
          <div
            style={{
              display: "inline-block",
              whiteSpace: "pre",
              fontSize: "12px",
              color: "#424242",
              userSelect: "none",
            }}
          >
            {timestamp2dateform(startTimestamp + value, 1)}
          </div>
          <div
            style={{
              display: "inline-block",
              whiteSpace: "pre",
              fontSize: "16px",
              color: "#000",
              userSelect: "none",
            }}
          >
            {timestamp2dateform(startTimestamp + value, 2)}
          </div>
        </Box>
      </div>
      <Box sx={{ width: "500px" }}>
        <Slider
          ref={sliderRef}
          aria-label="Timeline"
          color="secondary"
          value={value}
          onChange={(_, value) => handleSliderChange(value)}
          valueLabelFormat={(value) =>
            `${Math.round((value / (endTimestamp - startTimestamp)) * 100)}%`
          } // 라벨에 퍼센트 표시
          sx={{
            width: "100%",
            height: "6px",
            "& .MuiSlider-thumb": {
              width: "12px",
              height: "12px",
              backgroundColor: "#0275d8",
              boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
            },
            "& .MuiSlider-track": {
              backgroundColor: "#0275d8",
              height: "6px",
            },
            "& .MuiSlider-rail": {
              backgroundColor: "rgba(200, 200, 200, 0.5)",
              height: "6px",
            },
          }}
          size="medium"
          step={step}
          valueLabelDisplay="auto" // 자동 라벨 표시
          min={0}
          max={parseInt(endTimestamp) - parseInt(startTimestamp)}
          marks={false}
        />
      </Box>
    </div>
  );
};

export default LogMultiProgress;
